// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.links-formato {
  display: block;
  justify-content: center;
  background: linear-gradient(180deg, rgb(0, 0, 0) 0%, rgb(63, 63, 63) 50%, rgb(0, 0, 0) 100%);
}

/* Media query para dispositivos con un ancho de pantalla máximo de 767px (generalmente dispositivos móviles) */
@media (max-width: 767px) {
  .menu-icon {
    margin-right: 0.9rem;
    margin-left: 0.9rem;
  }
}
/* Media query para dispositivos con un ancho de pantalla máximo de 767px (generalmente tablets) */
@media (max-width: 1200px) {
  .button-menu {
    height: 50px;
    margin: 6px;
    width: 160px !important;
    font-size: 12px !important;
  }
  .btn-parques {
    align-content: center;
    width: 225px !important;
  }
  .dropdown-link {
    width: 290px !important;
  }
}
.button-menu {
  height: 50px;
  margin: 6px;
  width: 180px;
  background: linear-gradient(#0a71b1 0%, #25aff3 77%, #0a71b1 100%);
  color: rgb(255, 255, 255);
  border-color: #002c8b;
  font-size: 14px;
  font-family: "Saira", "Lucida Console", "Courier New", "monospace";
  border-radius: 10px;
  align-content: end;
  display: grid;
  text-align: center;
}

.button-menu:hover {
  background: white;
  color: rgb(0, 44, 139);
}

.size-parques {
  width: 250px !important;
}

.size-parques-select {
  background-color: black;
  color: rgb(255, 255, 255);
  font-family: "Saira", "Lucida Console", "Courier New", "monospace";
}

.w-dropdown-list {
  position: absolute;
  background: none;
  margin-left: 12px;
  z-index: 9999;
  display: block;
}

.dropdown-link {
  font-size: 13px;
  width: 320px;
}

.w-dropdown-btn, .w-dropdown-toggle, .w-dropdown-link {
  position: relative;
  vertical-align: top;
  text-decoration: none;
  padding: 20px;
}

.btn-parques {
  align-content: center;
  width: 300px;
}`, "",{"version":3,"sources":["webpack://./src/components/Layout/Links/links.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE,cAAA;EACA,uBAAA;EACA,4FCOkB;ADPpB;;AAGA,+GAAA;AACA;EAKE;IACE,oBAAA;IACA,mBAAA;EAJF;AACF;AAOA,kGAAA;AACA;EACE;IACE,YAAA;IACA,WAAA;IACA,uBAAA;IACA,0BAAA;EALF;EAOA;IACE,qBAAA;IACA,uBAAA;EALF;EAQA;IACE,uBAAA;EANF;AACF;AAWA;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,kEClCuB;EDmCvB,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,kECrCmB;EDsCnB,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;AATF;;AAYA;EACE,iBAAA;EACA,sBAAA;AATF;;AAYA;EACE,uBAAA;AATF;;AAYA;EACE,uBAAA;EACA,yBAAA;EACA,kECxDmB;AD+CrB;;AAYA;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,cAAA;AATF;;AAYA;EACE,eAAA;EACA,YAAA;AATF;;AAYA;EACE,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;AATF;;AAYA;EACE,qBAAA;EACA,YAAA;AATF","sourcesContent":["@import \"../../../styles/variables.scss\";\n\n.links-formato {\n  display: block;\n  justify-content: center;\n  background: $system-background;\n}\n\n/* Media query para dispositivos con un ancho de pantalla máximo de 767px (generalmente dispositivos móviles) */\n@media (max-width: 767px) {\n  // .links-formato {\n  //   display: none !important;\n  // }\n\n  .menu-icon {\n    margin-right: 0.9rem;\n    margin-left: 0.9rem;\n  }\n}\n\n/* Media query para dispositivos con un ancho de pantalla máximo de 767px (generalmente tablets) */\n@media (max-width: 1200px) {\n  .button-menu {\n    height: 50px;\n    margin: 6px;\n    width: 160px !important;\n    font-size: 12px !important;\n  }\n  .btn-parques{\n    align-content: center;\n    width: 225px !important;\n  }\n\n  .dropdown-link{\n    width: 290px !important;\n  }\n  \n  \n}\n\n.button-menu {\n  height: 50px;\n  margin: 6px;\n  width: 180px;\n  background: $buttom-menu-background;\n  color: rgb(255, 255, 255);\n  border-color: #002c8b;\n  font-size: 14px;\n  font-family: $font-family-system;\n  border-radius: 10px;\n  align-content: end;\n  display: grid;\n  text-align: center;\n}\n\n.button-menu:hover {\n  background: white;\n  color: rgb(0, 44, 139);\n}\n\n.size-parques{\n  width: 250px !important;\n}\n\n.size-parques-select{\n  background-color: black;\n  color: rgb(255, 255, 255);\n  font-family: $font-family-system;\n}\n\n.w-dropdown-list {\n  position: absolute;\n  background: none;\n  margin-left: 12px;\n  z-index: 9999;\n  display: block;\n}\n\n.dropdown-link {\n  font-size: 13px;\n  width: 320px;\n}\n\n.w-dropdown-btn, .w-dropdown-toggle, .w-dropdown-link {\n  position: relative;\n  vertical-align: top;\n  text-decoration: none;\n  padding: 20px;\n}\n\n.btn-parques{\n  align-content: center;\n  width: 300px;\n}","// BG\n$main-bg: #000000;\n$soft-bg: #384256;\n$dark-bg: #222b3c;\n// Text\n$main-color: white;\n$soft-color: #ddd;\n$dark-color: #2a3447;\n\n// System\n$buttom-menu-background: linear-gradient(#0a71b1 0%, #25aff3 77%, #0a71b1 100%);\n$font-family-system: \"Saira\", \"Lucida Console\", \"Courier New\", \"monospace\";\n$system-background: linear-gradient(180deg, rgb(0, 0, 0) 0%, rgb(63, 63, 63) 50%, rgb(0, 0, 0) 100%);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
